import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { PageMeta } from "@/components/PageMeta";
import { BRAND } from "@/config/brand";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const res = await api.post("/admin/auth/login", { email, password });
            localStorage.setItem("ys_admin_token", res.data.access_token);
            localStorage.setItem("ys_admin_user", JSON.stringify(res.data.admin));
            toast.success(`Welcome, ${res.data.admin.name}`);
            nav("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Invalid credentials");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F3F7F9] flex items-center justify-center px-4">
            <PageMeta title="Admin Sign In — YS Removals" description="YS Removals admin dashboard." />
            <div className="w-full max-w-md">
                <div className="flex items-center gap-3 justify-center text-[#001B3D] font-heading font-bold text-lg mb-6">
                    <img
                        src={BRAND.logo}
                        alt={BRAND.logoAlt}
                        className="h-11 w-11 rounded-md object-contain"
                        width={44}
                        height={44}
                    />
                    <span>YS Removals — Admin</span>
                </div>
                <form data-testid={ADMIN.loginForm} onSubmit={submit} className="rounded-2xl bg-white border border-[#17252D]/10 p-6 sm:p-8 space-y-4">
                    <div>
                        <Label>Email</Label>
                        <Input required type="email" data-testid="admin-login-email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div>
                        <Label>Password</Label>
                        <Input required type="password" data-testid="admin-login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <Button type="submit" disabled={busy} data-testid={ADMIN.loginSubmit} className="w-full bg-[#001B3D] hover:bg-[#001B3D]/90 text-white h-11 font-semibold">
                        {busy ? "Signing in…" : "Sign in"}
                    </Button>
                    <p className="text-xs text-[#17252D]/60 text-center">Default: admin@ysremovals.com / Admin@YS2025 (change in .env)</p>
                </form>
            </div>
        </div>
    );
}
